import Link from "next/link";
import { FC } from "react";

import {
  Account,
  UserIndustryMaster,
  PrefMaster,
  UserStatus1 as UserStatus,
} from "@/apis/clients";
import { AccountsListCard } from "@/components/organisms/accounts/AccountsListCard";
import { userStatusToString } from "@/libs/enums/enumStrings";

interface Props {
  account: Account;
  prefMaster: PrefMaster[];
  userIndustryMaster: UserIndustryMaster[];
}

export const BasicInfo: FC<Props> = ({
  account,
  prefMaster,
  userIndustryMaster,
}) => {
  const prefName = () => {
    const idx = prefMaster.findIndex((p) => p.id === account.prefecture_id);
    if (idx < 0) {
      return "";
    }
    return prefMaster[idx].pref_name;
  };

  const industryName = () => {
    if (account.industry_id === 99) {
      return account.industry_text ?? "";
    }
    const idx = userIndustryMaster.findIndex(
      (i) => i.id === account.industry_id,
    );
    if (idx < 0) {
      return "";
    }
    return userIndustryMaster[idx].industry_name;
  };

  const isIndividual = () => {
    return account.status === UserStatus.INDIVIDUAL;
  };

  const setDtLink = (text: string, link: string) => {
    return (
      <>
        {text}
        <Link
          href={link}
          className="inline-block ml-2 font-normal text-primary-dark hover:underline">
          
            変更
          
        </Link>
      </>
    );
  };

  const Lists = [
    {
      dt: setDtLink("区分", "/accounts/edit/type"),
      dd: userStatusToString(account.status),
    },
    {
      dt: isIndividual()
        ? "氏名"
        : setDtLink("担当者 氏名", "/accounts/edit/name"),
      dd: account.last_name + " " + account.first_name,
      border: !isIndividual(),
    },
    {
      dt: setDtLink(
        isIndividual() ? "フリガナ" : "担当者 フリガナ",
        "/accounts/edit/name-kana",
      ),
      dd:
        (account.last_name_kana ?? "") + " " + (account.first_name_kana ?? ""),
      border: true,
    },
    {
      dt: setDtLink("メールアドレス", "/accounts/edit/email"),
      dd: account.email,
      border: true,
    },
    {
      dt: setDtLink("パスワード", "/accounts/edit/password"),
      dd: "********",
      border: true,
    },
    {
      dt: setDtLink("電話番号", "/accounts/edit/tel"),
      dd: account.tel,
      border: true,
    },
    {
      dt: setDtLink(
        isIndividual() ? "住所" : "所在地",
        "/accounts/edit/address",
      ),
      dd: (
        <address className="space-y-2 not-italic">
          <p>{account.zip}</p>
          <p>{prefName()}</p>
          <p>{account.address}</p>
          <p>{account.building}</p>
        </address>
      ),
      border: true,
    },
    {
      dt: setDtLink("業種", "/accounts/edit/industry"),
      dd: industryName(),
    },
  ];

  !isIndividual() &&
    Lists.splice(1, 0, {
      dt: <>会社名</>,
      dd: account.company_name || "",
    });

  return <AccountsListCard title="基本情報" list={Lists} />;
};
